import { render, staticRenderFns } from "./SoldEvents.vue?vue&type=template&id=3b6aadd0&scoped=true"
import script from "./SoldEvents.vue?vue&type=script&lang=js"
export * from "./SoldEvents.vue?vue&type=script&lang=js"
import style0 from "./SoldEvents.vue?vue&type=style&index=0&id=3b6aadd0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6aadd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6aadd0')) {
      api.createRecord('3b6aadd0', component.options)
    } else {
      api.reload('3b6aadd0', component.options)
    }
    module.hot.accept("./SoldEvents.vue?vue&type=template&id=3b6aadd0&scoped=true", function () {
      api.rerender('3b6aadd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/SoldEvents.vue"
export default component.exports